import { render, staticRenderFns } from "./dashboardcollection.vue?vue&type=template&id=3a4ca363&"
import script from "./dashboardcollection.vue?vue&type=script&lang=js&"
export * from "./dashboardcollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports